<script setup lang="ts">
import { computed } from 'vue';
import { BIcon } from '@/design-system/components';
import LogItem from './LogItem.vue';
import type { AntennaReadingType } from '@/types/AntennaReadingType';

type PropsType = {
    readings: AntennaReadingType[];
    showAntennaName?: boolean;
    maxEpcs?: number;
    maxItems?: number;
    emptyMessage?: string;
    emptyIcon?: string;
    containerClass?: string;
    getAntennaName?: (antennaUuid: string) => string;
    getReaderName?: (antennaUuid: string) => string;
};

const props = withDefaults(defineProps<PropsType>(), {
    showAntennaName: false,
    maxEpcs: 10,
    maxItems: undefined,
    emptyMessage: 'No data',
    emptyIcon: 'mdi-inbox',
    containerClass: '',
    getAntennaName: () => '',
    getReaderName: () => '',
});

const displayedReadings = computed(() => {
    if (props.maxItems) {
        return props.readings.slice(0, props.maxItems);
    }

    return props.readings;
});
</script>

<template>
    <div :class="containerClass">
        <LogItem
            v-for="(reading, index) in displayedReadings"
            :key="index"
            :reading="reading"
            :show-antenna-name="showAntennaName"
            :max-epcs="maxEpcs"
            :antenna-name="showAntennaName ? getAntennaName(reading.antennaUuid) : ''"
            :reader-name="showAntennaName ? getReaderName(reading.antennaUuid) : ''"
        />

        <div
            v-if="readings.length === 0"
            class="text-center py-4 text-medium-emphasis"
        >
            <BIcon
                :icon="emptyIcon"
                size="large"
                class="mb-2"
            />
            <div>{{ emptyMessage }}</div>
        </div>
    </div>
</template>
